// extracted by mini-css-extract-plugin
module.exports = {"container":"PaneWrapper_container__6aawx","content":"PaneWrapper_content__BHpny","closeButton":"PaneWrapper_closeButton__3oMfS"};